import { render, staticRenderFns } from "./ROITableVDPDetails.vue?vue&type=template&id=544dec9b&scoped=true&"
import script from "./ROITableVDPDetails.vue?vue&type=script&lang=js&"
export * from "./ROITableVDPDetails.vue?vue&type=script&lang=js&"
import style0 from "./ROITableVDPDetails.vue?vue&type=style&index=0&id=544dec9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544dec9b",
  null
  
)

export default component.exports